import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';

import { MgIconModule } from '@app/src/app/icon';

import { GenericModule } from '../generic';
import { SystemAlertComponent } from './system-alert.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgIconModule,
    MatSnackBarModule,
    GenericModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
  ],
  declarations: [SystemAlertComponent],
  exports: [SystemAlertComponent],
})
export class SystemAlertModule {}
